import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { httpOptions } from "./headers";

@Injectable({ providedIn: 'root' })

export class TechnologiesManagementService {
  private technologiesManagementUrl = environment.technologiesManagementUrl;
  
  private httpOptions(session: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session
      }),
    };
  };

  constructor(private http: HttpClient) { }

  public getAllTechnologies() {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.technologiesManagementUrl+"/all",this.httpOptions(token));
  }

  public addNewTechnology(techName: string): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.post(this.technologiesManagementUrl +'/add', {"name": techName},this.httpOptions(token));
  }
  
  public getTechnologyById(id: any): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.technologiesManagementUrl + '/' + encodeURIComponent(id), this.httpOptions(token));
  }

  public addToolToTechnology(techId: string, toolName: string, toolProd: number): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.technologiesManagementUrl + '/' + encodeURIComponent(techId) + "/add-tool", {
    "name": toolName,
    "productivity": toolProd
    }, this.httpOptions(token));
  }
  
  public removeToolFromTechnology(techId: string, toolName: string): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.technologiesManagementUrl + '/' + encodeURIComponent(techId) + "/remove-tool", {
      "name": toolName,
      "productivity": 1 //dummy value not being used
    }, this.httpOptions(token));
  }

  public editToolFromTechnology(techId: string, oldToolName: string, newToolName: string, newToolProd: number): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.technologiesManagementUrl + '/' + encodeURIComponent(techId) + "/update-tool", {
      "oldToolName": oldToolName,
      "newTool": {
        "name":newToolName,
        "productivity":newToolProd
      }
    },  this.httpOptions(token))
  }
  
  public editTechnology(techId: string, toolName: string, active: boolean): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.technologiesManagementUrl + '/' + encodeURIComponent(techId) + "/edit", {
      "name": toolName,
      "active": active
    },  this.httpOptions(token))
  }
  
  removeTechnology(techID: string): Observable<any> {
      const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
      return this.http.delete(this.technologiesManagementUrl + '/' + techID, this.httpOptions(token));
  }
  
  public getAllActiveTechnologies() {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.technologiesManagementUrl+"/all-active",this.httpOptions(token));
  }
  
  


}
